













import Vue from "vue";

export default Vue.extend({
  name: "PxQuestionaryRange",

  props: {
    value: {
      type: [Object, Array],
      default: () => null,
    },

    isValid: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      values: {
        min: "",
        max: "",
      },
    };
  },

  watch: {
    values: {
      deep: true,
      handler(newVal) {
        const newValues = {
          min: parseFloat(newVal.min.replace(",", "")),
          max: parseFloat(newVal.max.replace(",", "")),
        };

        this.emitValueChanges(newValues);
        this.validateField(newValues);
      },
    },
  },

  methods: {
    /**
     * Emit value changes to the parent component.
     */
    emitValueChanges(values: any) {
      this.$emit("input", values);
      this.$emit("change", values);
    },

    validateField(values: any) {
      const isValid =
        values.min !== undefined &&
        values.max !== undefined &&
        values.min < values.max;

      this.$emit("update:isValid", isValid);
    },
  },
});
